import {Stack, styled} from '@mui/material';

const StyledStack = styled(Stack)`
	background-color: ${({theme}) => theme.colors.gray['10Percent']};
	padding: 10px 12px;
	border-radius: 8px;

	svg {
		min-width: 16px;
		min-height: 20px;
	}

	${({theme}) => theme.breakpoints.down('md')} {
		margin-top: auto;
		align-items: flex-start;
	}
`;

export {StyledStack};
